import { Templates } from "@rjsf/mui"
import type { FieldTemplateProps } from "@rjsf/utils"

export function FieldTemplate(props: FieldTemplateProps) {
  const isAdditionalProp = props.schema.__additional_property
  const isHidden = isAdditionalProp

  return <Templates.FieldTemplate {...props} hidden={isHidden} />
}
